import React, { useState, useEffect } from "react";
import "./App.css";
import SearchBar from "./Component/SearchBar";
import axios from "axios";

function App() {
  const [popularQuestions, setPopularQuestions] = useState([]);

  useEffect(() => {
    // Fetch popular-questions from the Flask server
    const fetchQuestions = async () => {
      try {
        const response = await axios.get('https://nlp-project-production.up.railway.app/popular-questions');
        setPopularQuestions(response.data);
      } catch (error) {
        console.error("Error fetching popular questions: ", error);
      }
    };

    fetchQuestions();
  }, []);



  return (
    <div className="App">
      <SearchBar placeholder="ابحث هنا ..." />
      <h2>الأسئلة الشائعة</h2>
      <div className="popular-questions-container">
        <ul className="popular-questions">
          {popularQuestions.map((question, index) => (
            <li key={index} className="question">
              {question.q}
              <p className="popular-answer">{question.a}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}



export default App;
